"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalytics = void 0;
const useFullStoryAnalytics_1 = require("./useFullStoryAnalytics");
const useAnalytics = () => {
    const { sendEvent: sendFSEvent } = (0, useFullStoryAnalytics_1.useFullStoryAnalytics)();
    return {
        sendEvent: (name, data) => {
            sendFSEvent(name, data);
        },
    };
};
exports.useAnalytics = useAnalytics;
//# sourceMappingURL=useAnalytics.js.map